module.exports = {
  login: '/user/login/',
  login_google: '/user/login_firebase/',
  token_refresh: '/user/api/token/refresh/',
  reset_password: '/user/reset_password/',
  set_new_password: '/user/reset/',
  get_menu: '/user/menu/',
  get_filters_options: '/user/filters/',
  // User Panel
  get_user_info_panel: '/user/panel/detail/',
  get_user_alert_panel: '/user/panel/alerts_detail/',
  get_user_devices_panel: '/user/panel/devices_detail/',
  get_user_logs_panel: '/user/panel/logs_detail/',
  update_user_info: '/user/panel/edit/',
  update_active_rule: '/user/panel/update_active_rule/',

  send_command: '/device/send_command/',
  // get_address: "/device/get_address/",
  // get_alerts_notifications: '/alert/notification/',

  // socket
  socket_device_position: '/ws/device_position/',
  socket_device_position_all: '/ws/device_position_all/',
  socket_alert_panel: '/ws/alert/',
  // socket_alert_chat: '/ws/reaction/',
  // socket_alert_history: '/ws/history/',

  // --------filtros de selectores------------------
  get_users_filter: '/user/get_users_filter/',
  get_carriers_filter: '/company/get_carriers_filter/',
  get_clients_filter: '/company/get_clients_filter/',
  get_drivers_filter: '/company/get_drivers_filter/',
  get_vehicles_filter: '/company/get_vehicles_filter/',
  get_vehicle_groups_filter: '/company/get_vehicle_groups_filter/',
  get_companies_filter: '/company/get_companies_filter/',
  get_gps_devices: '/device/gps_device/get_gps_devices/',
  get_all_highways: '/company/get_all_highways/',
  get_all_porchs: '/company/get_all_porchs/',

  get_name_by_id: '/user/get_name_by_id/',
  save_preference: '/user/save_preference/',
  save_preference_map: '/user/save_preference_map/',
  save_preference_filter: '/user/save_preference_filter/',

  //report
  // report_mileage: '/vehicle/report_mileage/',

  // --------------------Url Api Alert--------------------
  // alert
  save_alert: '/alert/create/',
  edit_alert: '/alert/edit/',
  alert_delete: '/alert/delete/',
  get_alert_list: '/alert/list/',
  export_alert_list: '/alert/export_list/',

  // Reporte consolidado de alertas
  alert_report_consolidated_list: '/alert/report/consolidated/list/',
  alert_report_consolidated_list_export: '/alert/report/consolidated/list_export/',
  alert_report_consolidated_access: '/alert/report/consolidated/access/',

  // Alert panel
  sos_feature_access: '/alert/sos-feature-access/',
  get_alerts_panel: '/alert/panel/',
  send_alert_opened: '/alert/panel/:id/opened/',
  get_allowed_vehicles: '/alert/panel/:id/allowed-vehicles/',
  reassign_vehicle: '/alert/panel/:id/reassign-vehicle/',
  register_sos_command_history: "/alert/panel/:id/command-history/",
  get_sos_alert_types: '/alert/panel/alert-types/',
  create_manual_sos_alert: '/alert/panel/manual/',
  search_manual_sos_alert_vehicles: '/alert/panel/manual/search-vehicles/',
  get_sos_alert_history: '/alert/panel/:id/history/',
  sos_alert_export_history: "/alert/panel/:id/export-history/",
  update_sos_alert_management: '/alert/panel/:id/management/',
  get_alert_detail: '/alert/panel/detail/',
  send_monitor_comment: '/reaction/create_monitor_comment/',
  update_history : '/alert/panel/history/',
  reject_alert: '/alert/panel/reject/',
  get_alert_device_detail: '/alert/device/detail/',
  get_device_detail: '/device/gps_device/detail/',

  // CDM
  get_user_preference_filter: '/company/get_user_preference_filter/',
  get_user_panel: '/company/home_user/',
  get_gps_panel: '/company/home_gps/',
  get_gps_panel_list: '/company/home_gps_list/',
  export_gps_device_following_list: '/company/export-following-xlsx/',
  get_device_detail_cdm: '/device/gps_device/detail_cdm/',
  get_commands : '/company/get_commands/',

  get_user_preference_map: '/company/get_user_preference_map/',

  // rule
  get_rule_list: '/alert/rule/list/',

  // ----------------Url Api Vehicle-------------------------
  // vehicle
  get_vehicle_list: '/vehicle/vehicle-datatable/',
  get_allowed_vehicles_count: '/vehicle/allowed-vehicles-count/',
  vehicle_delete: '/vehicle/delete/',
  vehicle_add: '/vehicle/add/',
  vehicle_remove: '/vehicle/remove/',
  save_vehicle: '/vehicle/create/',
  edit_vehicle: '/vehicle/edit/',
  export_vehicle_list: '/vehicle/vehicle-export-xlsx/',
  save_vehicle_xlsx: "/vehicle/save-vehicle-xlsx/",

  // device_type
  get_device_type_list: '/vehicle/device_type-datatable/',
  device_type_delete: '/vehicle/device_type/delete/',
  save_device_type: '/vehicle/device_type/create/',
  edit_device_type: '/vehicle/device_type/edit/',
  export_device_type_list: '/vehicle/device_type-export-xlsx/',

  // vehicle_brand
  get_vehicle_brand_list: '/vehicle/vehicle_brand-datatable/',
  vehicle_brand_delete: '/vehicle/vehicle_brand/delete/',
  save_vehicle_brand: '/vehicle/vehicle_brand/create/',
  edit_vehicle_brand: '/vehicle/vehicle_brand/edit/',
  export_vehicle_brand_list: '/vehicle/vehicle_brand-export-xlsx/',

  // vehicle_model
  get_vehicle_model_list: '/vehicle/vehicle_model-datatable/',
  vehicle_model_delete: '/vehicle/vehicle_model/delete/',
  save_vehicle_model: '/vehicle/vehicle_model/create/',
  edit_vehicle_model: '/vehicle/vehicle_model/edit/',
  export_vehicle_model_list: '/vehicle/vehicle_model-export-xlsx/',

  // vehicle_type
  get_vehicle_type_list: '/vehicle/vehicle_type-datatable/',
  vehicle_type_delete: '/vehicle/vehicle_type/delete/',
  save_vehicle_type: '/vehicle/vehicle_type/create/',
  edit_vehicle_type: '/vehicle/vehicle_type/edit/',
  export_vehicle_type_list: '/vehicle/vehicle_type-export-xlsx/',

  // equipment
  get_equipment_list: '/vehicle/equipment-datatable/',
  equipment_delete: '/vehicle/equipment/delete/',
  save_equipment: '/vehicle/equipment/create/',
  edit_equipment: '/vehicle/equipment/edit/',
  export_equipment_list: '/vehicle/equipment-export-xlsx/',

  // vehicle_group
  get_vehicle_group_list: '/vehicle/vehicle_group-datatable/',
  vehicle_group_delete: '/vehicle/vehicle_group/delete/',
  save_vehicle_group: '/vehicle/vehicle_group/create/',
  edit_vehicle_group: '/vehicle/vehicle_group/edit/',
  export_vehicle_group_list: '/vehicle/vehicle_group-export-xlsx/',
  vehicle_group_add_vehicles: '/vehicle/vehicle_group/add_vehicles/',
  vehicle_group_remove_vehicles: '/vehicle/vehicle_group/remove_vehicles/',
  resolve_vehicle_group_massive_plates: "/vehicle/vehicle_group/resolve-massive-plates/",


  // --------------------Url Api Company--------------------
  // company
  get_company_list: '/company/company-datatable/',
  company_delete: '/company/delete/',
  save_company: '/company/create/',
  edit_company: '/company/edit/',
  export_company_list: '/company/company-export-xlsx/',

  // template
  get_template_list: '/company/template/template-datatable/',
  template_delete: '/company/template/delete/',
  save_template: '/company/template/create/',
  edit_template: '/company/template/edit/',
  export_template_list: '/company/template/template-export-xlsx/',
  get_certificates: '/company/template/get_certificates/',
  get_certificates_external: '/company/template/external/get_certificates/',

  // client
  get_client_list: '/company/client/client-datatable/',
  client_delete: '/company/client/delete/',
  save_client: '/company/client/create/',
  edit_client: '/company/client/edit/',
  export_client_list: '/company/client/client-export-xlsx/',

  // service
  get_service_list: '/company/service-datatable/',
  service_delete: '/company/service/delete/',
  save_service: '/company/service/create/',
  edit_service: '/company/service/edit/',
  export_service_list: '/company/service-export-xlsx/',

  //TAG
  get_control_tag_permissions: '/company/get_control-tag-permissions/',

  // iButton
  get_report_drivers_list: '/company/report_drivers_list/',

  // --------------------Url Api Company--------------------
  // user_log
  get_log_user_list: '/log/log_user-datatable/',
  export_log_user_list: '/log/log_user-export-xlsx/',

   // ----------------Url Api Zone-------------------------
  //zone
  get_zone_list: '/zone/list/',
  get_type_zone_list: '/zone/type_zone/list/',
  get_zone_marker_list: '/zone/zone_marker/list/',
  save_zone_maker_icon: '/zone/zone_marker_icon/create/',
  edit_zone_maker_icon : '/zone/zone_marker_icon/edit/',

  // panel_interest_places: '/zone/panel_interest_places/',

  // --------------------Url Api User--------------------
  // user
  get_user_list: '/user/user-datatable/',
  user_delete: '/user/delete/',
  save_user: '/user/create/',
  edit_user: '/user/edit/',
  export_user_list: '/user/user-export-xlsx/',
  bulk_create_user_options: '/user/bulk-create/options/',
  bulk_create_user_template: '/user/bulk-create/template/',
  bulk_create_user: '/user/bulk-create/',

  // profile
  get_profile_list: '/user/profile-datatable/',
  profile_delete: '/user/profile/delete/',
  save_profile: '/user/profile/create/',
  edit_profile: '/user/profile/edit/',
  export_profile_list: '/user/profile-export-xlsx/',

   // user_contact
  get_user_contact_list: '/user/user_contact-datatable/',
  user_contact_delete: '/user/user_contact/delete/',
  save_user_contact: '/user/user_contact/create/',
  edit_user_contact: '/user/user_contact/edit/',
  export_user_contact_list: '/user/user_contact-export-xlsx/',

  // user_group
  get_user_group_list: '/user/user_group-datatable/',
  user_group_delete: '/user/user_group/delete/',
  save_user_group: '/user/user_group/create/',
  edit_user_group: '/user/user_group/edit/',
  export_user_group_list: '/user/user_group-export-xlsx/',

  // --------------------Url Api Device--------------------
  // gps_device
  get_gps_device_list: '/device/gps_device-datatable/',
  gps_device_delete: '/device/gps_device/delete/',
  save_gps_device: '/device/gps_device/create/',
  edit_gps_device: '/device/gps_device/edit/',
  export_gps_device_list: '/device/gps_device-export-xlsx/',
  get_gps_device_kpis: '/device/gps_device/kpis/',

  // Use Report
  get_info_report_use: '/device/get_info_report_use/',

  // Audit
  get_gps_devices_audit: '/device/gps_device/get_gps_devices_audit/',

  get_gps_device_type_list: '/device/gps_device_type-datatable/',
  gps_device_type_delete: '/device/gps_device_type/delete/',
  save_gps_device_type: '/device/gps_device_type/create/',
  edit_gps_device_type: '/device/gps_device_type/edit/',
  export_gps_device_type_list: '/device/gps_device_type-export-xlsx/',

  get_gps_device_command_list: '/device/gps_device_command-datatable/',
  gps_device_command_delete: '/device/gps_device_command/delete/',
  save_gps_device_command: '/device/gps_device_command/create/',
  edit_gps_device_command: '/device/gps_device_command/edit/',
  export_gps_device_command_list: '/device/gps_device_command-export-xlsx/',

  get_log_gps_device_command_list: '/device/log_gps_device_command-datatable/',
  log_gps_device_command_delete: '/device/log_gps_device_command/delete/',
  export_log_gps_device_command_list: '/device/log_gps_device_command-export-xlsx/',

  // --------------------Url Api Notification--------------------
  // notification
  get_notification_list: '/notification/list/',
  save_notification: '/notification/create/',

  // --------------------MIGPS PROTECT--------------------
  // dashboard
  get_driver_access_dashboard_overview: '/driver-access/dashboard/overview/',
  get_driver_access_dashboard_health: '/driver-access/dashboard/health/',
  driver_access_dashboard_health_export: '/driver-access/dashboard/health/export/',
  get_driver_access_dashboard_ranking: '/driver-access/dashboard/ranking/',
  get_driver_access_dashboard_alerts: '/driver-access/dashboard/alerts/',
  driver_access_dashboard_alerts_export: '/driver-access/dashboard/alerts/export/',
  get_driver_access_dashboard_users: '/driver-access/dashboard/users/',
  get_driver_access_dashboard_companies: '/driver-access/dashboard/companies/',
  // activación de cuentas
  get_driver_access_pending_accounts: '/driver-access/accounts/pending-datatable/',
  export_driver_access_accounts: '/driver-access/accounts/export/',
  driver_access_update_account: '/driver-access/accounts/update/',
  driver_access_deactivate_account: '/driver-access/accounts/deactivate/',
  driver_access_reactivate_account: '/driver-access/accounts/reactivate/',
  driver_access_activate_account: '/driver-access/accounts/activate/',
  driver_access_activate_by_email: '/driver-access/accounts/activate-by-email/',
  get_driver_access_account_user_groups: '/driver-access/accounts/user-groups/',
  driver_access_reject_account: '/driver-access/accounts/reject/',
  // asignación de patentes
  get_driver_access_assignments: '/driver-access/assignments/datatable/',
  export_driver_access_assignments: '/driver-access/assignments/export/',
  driver_access_assignment_create: '/driver-access/assignments/create/',
  driver_access_assignment_revoke: '/driver-access/assignments/revoke/',
  // habilitaciones remotas
  get_driver_access_remote_pending: '/driver-access/remote/pending-datatable/',
  driver_access_remote_authorize: '/driver-access/remote/authorize/',
  driver_access_remote_reject: '/driver-access/remote/reject/',
  driver_access_remote_on_demand: '/driver-access/remote/on-demand/',
  // selectores
  get_driver_access_users: '/driver-access/selectors/users/',
  get_driver_access_accounts: '/driver-access/selectors/accounts/',
  // wise sharing: usuarios habilitados para reservar
  get_wise_sharing_members: '/driver-access/sharing/members/datatable/',
  wise_sharing_member_create: '/driver-access/sharing/members/create/',
  wise_sharing_member_update: '/driver-access/sharing/members/update/',
  wise_sharing_member_disable: '/driver-access/sharing/members/disable/',
  get_wise_sharing_member_clients: '/driver-access/sharing/members/clients/',
  // wise sharing: reglas por compañía y por cliente
  get_wise_sharing_policies: '/driver-access/sharing/policies/',
  wise_sharing_policy_update: '/driver-access/sharing/policies/update/',
  // wise sharing: calendario de reservas
  get_wise_sharing_reservations_calendar: '/driver-access/sharing/reservations/calendar/',
  wise_sharing_reservation_create: '/driver-access/sharing/reservations/create/',
  wise_sharing_reservation_update: '/driver-access/sharing/reservations/update/',
  get_wise_sharing_reservation_drivers: '/driver-access/sharing/reservations/drivers/',
  wise_sharing_reservation_cancel: '/driver-access/sharing/reservations/cancel/',
  wise_sharing_reservation_finish: '/driver-access/sharing/reservations/finish/',
  // wise sharing: vehículos y su cliente
  get_wise_sharing_vehicles: '/driver-access/sharing/vehicles/datatable/',
  wise_sharing_vehicle_update: '/driver-access/sharing/vehicles/update/',
};